<template>
    <div class="carBox carBoxLeft">
        <div class="newBox">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>选择日期：</label>
                    <el-date-picker v-model="folder" value-format="yyyy-MM-dd" placeholder="选择报文日期"></el-date-picker>
                </div>
                <div class="searchGroup">
                    <label>设备编号：</label>
                    <el-input v-model="filter" clearable @keyup.enter.native="doSearch"></el-input>
                </div>   
                <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
            </div>
            <el-card class="box-card">
                <div class="mainBody">
                    <div class="btnBox">
                        <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                    </div>
                    <div class="dataBox">
                        <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                            <el-table-column prop="fileName" label="文件名称"></el-table-column>
                            <el-table-column prop="fileSize" label="文件大小"></el-table-column>
                            <el-table-column label="操作" width="160" align="center">
                                <template slot-scope="scope">
                                    <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-card>
        </div>
        <FileFilter
            width="1800px"
            :folder="folder"
            :fileName="fileName"
            title="筛选数据"
            :isshow="filtershow"
            @on-close="closeFilterDialog">
        </FileFilter>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { downMsgFile } from '@/api/annex'
import FileFilter from "./fileFilter"

export default {
    name: 'messageLogList',
    mixins: [listutil],
    components: { Btns, LabBtns, FileFilter},
    data() {
        return {
            m_name: '报文日志',
            menu_id: 1920,
            list_url: "/api/admin/messagelog/fileList",
            folder: '',
            filter: '',
            fileName: '',
            del_Obj:{
                url:'/api/admin/messagelog/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            sortData: {
                prop: 'add_time',
                order: 'descending'
            },
            filtershow: false,
        };
    },
    methods: {
        initPageParams() {
            let date1 = this.formatDateToYMD();
            this.folder = date1
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            let para = {
                "folder": this.folder,
                "filter": this.filter
            }
            getListData(this.list_url, para).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data;
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        doSearch() {
            this.getListData()
        },
        down(index, row){
            downMsgFile(this.folder, row.fileName).then(res=> {
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        filterData(index, row){
            this.fileName = row.fileName
            this.filtershow = true
        },
        closeFilterDialog(){
            this.filtershow = false
        },
        formatDateToYMD(date = new Date()) {
            // 获取年份
            const year = date.getFullYear();
            // 获取月份（注意月份从0开始，需要+1），不足两位补0
            const month = String(date.getMonth() + 1).padStart(2, '0');
            // 获取日期，不足两位补0
            const day = String(date.getDate()).padStart(2, '0');
            // 拼接成 yyyy-MM-dd 格式
            return `${year}-${month}-${day}`;
        },
    }
};
</script>